module.exports = __webpack_public_path__ + "img/jd_50_gift_card.6ccd1cfe.png";